import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@src/app/_guards/auth.guard';
import { MailerService } from '@src/app/mailer/mailer.service';
import { SharedFeaturesModule } from '@src/app/shared_features/shared-features.module';
import { MailerComponent } from './components/mailer/mailer.component';

const routes: Routes = [
    {
        path: 'mailer',
        children: [
            {
                path: '',
                component: MailerComponent,
                data: {
                    title: 'Nástěnka',
                    breadcrumb: [
                        {
                            label: 'Nástěnka',
                            url: '',
                        },
                    ],
                },
            },
        ],
        canActivate: [AuthGuard],
    },
];

@NgModule({
    declarations: [MailerComponent],
    imports: [RouterModule.forChild(routes), SharedFeaturesModule],
    exports: [MailerComponent],
    providers: [MailerService],
})
export class MailerModule {}
